(function ($, root, undefined) {$(function () {
    console.log('Hallo Welt')
})})(jQuery, this);
